import React from "react";

import { Group, Namespace, useTranslate } from "localization";
import { Modal } from "minimum-ui/core";
import { color } from "minimum-ui/tokens";
import { Methodology } from "types/Methodology";
import { DefinitionList } from "ui/core";

import Description from "./Description";

const MethodologyDetails: React.FC<{
  open: boolean;
  onClose: () => void;
  methodology: Methodology | null;
}> = ({ open, onClose, methodology }) => {
  const { translate } = useTranslate(Namespace.METHODOLOGIES);

  if (!open || !methodology) {
    return null;
  }

  const [scopeValue, categoryValue] =
    methodology.scopeCategoryOverride?.split(".") ?? [];

  const categoryNames = translate("scope3CategoryNames", {
    namespace: Namespace.DEFAULT,
    group: Group.SCOPE_3,
    returnObjects: true,
  }) as Record<number, string>;

  const categoryName =
    scopeValue === "3" && categoryValue
      ? categoryNames[Number(categoryValue)]
      : undefined;

  const scopeCategoryLabel = categoryName
    ? `Scope ${scopeValue} Category ${categoryValue} (${categoryName})`
    : scopeValue
    ? `Scope ${scopeValue}`
    : "-";

  return (
    <Modal
      isOpen={open}
      onDismiss={onClose}
      title={translate("methodologyDetails")}
      size="md"
      backgroundColor={color.basic.white}
      content={
        <>
          <DefinitionList>
            <DefinitionList.Term>
              {translate("name", { namespace: Namespace.DEFAULT })}
            </DefinitionList.Term>
            <DefinitionList.Desc>
              {methodology?.methodologyLabel || methodology?.name}
            </DefinitionList.Desc>
            {methodology?.version && (
              <>
                <DefinitionList.Term>
                  {translate("version", { namespace: Namespace.DEFAULT })}
                </DefinitionList.Term>
                <DefinitionList.Desc>
                  {methodology?.version || "-"}
                </DefinitionList.Desc>
              </>
            )}
            {methodology?.scopeCategoryOverride && (
              <>
                <DefinitionList.Term>
                  {translate("scopeCategoryOverride")}
                </DefinitionList.Term>
                <DefinitionList.Desc>{scopeCategoryLabel}</DefinitionList.Desc>
              </>
            )}
          </DefinitionList>
          <Description html={methodology?.description} />
        </>
      }
    />
  );
};

export default MethodologyDetails;
